import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { ITargetsData, ITargetsDataError, RuleType } from "components/product-collection/footer/types";

export class RequiredColumnsRule extends Validator<ITargetsData[], ITargetsDataError> {
    requiredColumns: string[];

    constructor(requiredColumns: string[]) {
        super();
        this.requiredColumns = requiredColumns;
    }

    validate(model: ITargetsData[], errors: ITargetsDataError): ITargetsDataError {
        let missingColumns = [];
        if (!errors[RuleType.RequiredColumnsRule]) {
            const headers = Object.keys(model[0] || {});
            missingColumns = this.requiredColumns.reduce((acc, column) => {
                const expression = buildColumnExpression(column);

                !headers.some((header) => expression.test(header)) && acc.push(column);
                return acc;
            }, []);
        }

        const validationErrors = missingColumns.length
            ? {
                  ...errors,
                  [RuleType.RequiredColumnsRule]: formatMessage("Your file is missing required field(s): |fields|", {
                      fields: missingColumns.join(", "),
                  }),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
